import React from 'react';
import {IconButton, Tooltip} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

const NewConversationButton = ({onClick, placement = 'left'}) => (
    <Tooltip title="New conversation" placement={placement} enterDelay={600} enterNextDelay={600}>
        <IconButton size="small" onClick={onClick} aria-label="New conversation">
            <AddIcon fontSize="small"/>
        </IconButton>
    </Tooltip>
);

export default NewConversationButton;
